import React, { useState, useEffect } from "react";
import "./VmCreateComponent.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import leftArrow from "../../../../assests/leftArrow.svg";
import IconButton from "@mui/material/IconButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Chip from "@mui/material/Chip";
import cancel from "../../../../assests/cancel.svg";
import Dropdown from "react-bootstrap/Dropdown";
import filter from "../../../../assests/filterIcon.svg";
import search from "../../../../assests/search.svg";
import Modal from "@mui/material/Modal";
import Table from "react-bootstrap/Table";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";

const VmCreateComponent = (props) => {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();

  const [state, setState] = useState({
    showWarehouseList: false,
    showVMTypeList: false,
    showHardwareList: false,
    showCorporateList: false,
    anchorElConsumerApp: null,
    anchorElHealthApp: null,
    showStateList: false,
    showCityList: false,
    showLocationType: false,
    showCohortList: false,
    open: false,
    searchTerm: "",
    anchorEl: null,
  });

  const [selectedCohorts, setSelectedCohorts] = useState([]);

  const handleOpen = () => setState({ ...state, open: true });
  const handleClose = () => setState({ ...state, open: false });

  const cohortBack = () => navigate(-1);

  const handleConsumerAppClick = (event) => {
    setState({ ...state, anchorElConsumerApp: event.currentTarget });
  };

  const handleHealthAppClick = (event) => {
    setState({ ...state, anchorElHealthApp: event.currentTarget });
  };

  const handleConsumerAppSelect = (value) => {
    setState({ ...state, anchorElConsumerApp: null });
    props.handleInputChange("consumerAppEnabled", value);
  };

  const handleHealthAppSelect = (value) => {
    setState({ ...state, anchorElHealthApp: null });
    props.handleInputChange("healthAppEnabled", value);
  };

  const handleVMTypeChange = (selectedVMTypeId) => {
    props.handleInputChange("machine_type_id", selectedVMTypeId);
    setState({ ...state, showVMTypeList: false });
  };

  const handleLocationTypeChange = (selectedLocationType) => {
    props.handleInputChange("location_type_id", selectedLocationType);
    setState({ ...state, showLocationType: false });
  };

  const goback = () => navigate(-1);

  const handleWarehouseChange = (selectedWarehouseId) => {
    props.handleInputChange("warehouse_id", selectedWarehouseId);
    setState({
      ...state,
      showWarehouseList: false,
      anchorEl: null,
      searchTerm: "",
    });
  };

  const handleSearchChange = (event) => {
    setState({ ...state, searchTerm: event.target.value });
  };

  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
      showWarehouseList: true,
    });
  };

  const handleClose1 = () => {
    setState({ ...state, showWarehouseList: false, anchorEl: null });
  };

  const filteredWarehouseList = props.warehouseList
    .filter((warehouse) =>
      warehouse.warehouseName
        .toLowerCase()
        .includes(state.searchTerm.toLowerCase()),
    )
    .sort((a, b) => a.warehouseName.localeCompare(b.warehouseName));

  const handleCorporateChange = (selectedCorporateId) => {
    props.handleInputChange("corporate_id", selectedCorporateId);
    setState({ ...state, showCorporateList: false });
  };

  const handleHardwareChange = (selectedHardwareId) => {
    props.handleInputChange("hardware_type_id", selectedHardwareId);
    setState({ ...state, showHardwareList: false });
  };

  const handleTypeChange = (e) => {
    props.setFormData({
      ...props.formData,
      type: e.target.value,
      type_detail: "",
      vm_operation_type: "", // Reset operation type when franchise type changes
    });
  };

  const handleDetailChange = (e) => {
    props.setFormData({
      ...props.formData,
      type_detail: e.target.value,
    });
  };

  const handleOperationTypeChange = (e) => {
    props.setFormData({
      ...props.formData,
      vm_operation_type: e.target.value,
    });
  };

  const handlePaymentChange = (selectedPayments) => {
    props.handleInputChange("payment_config_ids", selectedPayments);
  };

  const handleDeletePaymentChip = (event, paymentId) => {
    event.stopPropagation();
    const updatedPayments = props.formData.payment_config_ids.filter(
      (id) => id !== paymentId,
    );
    handlePaymentChange(updatedPayments);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "1390px",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    maxHeight: "90vh",
    overflowY: "auto",
  };

  return (
    <div className="vm-create-container">
      <div className="vm-create-sidebar">
        <Sidebar />
      </div>

      <div className="vm-create-content">
        <div className="vm-create-header">
          <img
            onClick={goback}
            className="vm-create-back-arrow"
            src={leftArrow}
            alt="Back"
          />
          <h2 className="vm-create-title">Create a VM</h2>
        </div>

        <div className="vm-create-main-container">
          <div className="vm-create-form-container">
            {/* Section 1 */}
            <div className="vm-create-form-section">
              <div className="vm-create-section-number">1</div>

              <TextField
                className="vm-create-input"
                fullWidth
                label="VM Name"
                autoComplete="off"
                value={props.formData.vmName}
                onChange={(e) =>
                  props.handleInputChange("vmName", e.target.value)
                }
              />

              <FormControl className="vm-create-select">
                <InputLabel>VM Type</InputLabel>
                <Select
                  label="VM Type"
                  value={props.formData.machine_type_id}
                  onClick={() => setState({ ...state, showVMTypeList: true })}
                >
                  {props.vmTypeList.list &&
                    props.vmTypeList.list.map((el, index) => (
                      <MenuItem
                        key={index}
                        value={el.id}
                        onClick={() => handleVMTypeChange(el.id)}
                      >
                        {el.type}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <FormControl className="vm-create-select">
                <InputLabel>Hardware Type</InputLabel>
                <Select
                  label="Hardware Type"
                  value={props.formData.hardware_type_id}
                  onClick={() => setState({ ...state, showHardwareList: true })}
                >
                  {props.hardwareList &&
                    props.hardwareList.map((el, index) => (
                      <MenuItem
                        key={index}
                        value={el.id}
                        onClick={() => handleHardwareChange(el.id)}
                      >
                        {el.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <FormControl className="vm-create-select">
                <InputLabel>Warehouse</InputLabel>
                <Select
                  label="Warehouse"
                  value={props.formData.warehouse_id || ""}
                  onChange={(e) => handleWarehouseChange(e.target.value)}
                  onOpen={handleClick}
                  onClose={handleClose1}
                  renderValue={(selected) => {
                    const selectedWarehouse = filteredWarehouseList.find(
                      (el) => el.warehouseId === selected,
                    );
                    return selectedWarehouse
                      ? selectedWarehouse.warehouseName
                      : "";
                  }}
                >
                  <MenuItem disableRipple>
                    <TextField
                      placeholder="Search Warehouse"
                      value={state.searchTerm}
                      onChange={handleSearchChange}
                      fullWidth
                      onClick={(e) => e.stopPropagation()}
                      onKeyDown={(e) => e.stopPropagation()}
                    />
                  </MenuItem>

                  {filteredWarehouseList.length > 0 ? (
                    filteredWarehouseList.map((el) => (
                      <MenuItem key={el.warehouseId} value={el.warehouseId}>
                        {el.warehouseName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No results found</MenuItem>
                  )}
                </Select>
              </FormControl>

              <FormControl className="vm-create-select">
                <InputLabel>Corporate</InputLabel>
                <Select label="Corporate">
                  {props.corporateList &&
                    props.corporateList.map((el, index) => (
                      <MenuItem
                        key={index}
                        value={el.id}
                        onClick={() => handleCorporateChange(el.id)}
                      >
                        {el.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <FormControl className="vm-create-select">
                <InputLabel>Consumer App Enabled</InputLabel>
                <Select
                  label="Consumer App Enabled"
                  value={props.formData.consumerAppEnabled}
                  onChange={(e) => handleConsumerAppSelect(e.target.value)}
                  onClick={handleConsumerAppClick}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </FormControl>

              <FormControl className="vm-create-select">
                <InputLabel>Health App Enabled</InputLabel>
                <Select
                  label="Health App Enabled"
                  value={props.formData.healthAppEnabled}
                  onChange={(e) => handleHealthAppSelect(e.target.value)}
                  onClick={handleHealthAppClick}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </FormControl>

              <FormControl className="vm-create-select">
                <InputLabel>Internet Provider</InputLabel>
                <Select
                  label="Internet Provider"
                  value={props.formData.internet_provider || ""}
                  onChange={(e) => {
                    props.setFormData({
                      ...props.formData,
                      internet_provider: e.target.value,
                    });
                  }}
                >
                  <MenuItem value="JIO">JIO</MenuItem>
                  <MenuItem value="VI">VI</MenuItem>
                  <MenuItem value="Airtel">Airtel</MenuItem>
                  <MenuItem value="Wi-Fi provide by us">
                    Wi-Fi provide by us
                  </MenuItem>
                  <MenuItem value="Wi-Fi provide by Them">
                    Wi-Fi provide by Them
                  </MenuItem>
                  <MenuItem value="LAN by us">LAN by us</MenuItem>
                  <MenuItem value="LAN by Them">LAN by Them</MenuItem>
                </Select>
              </FormControl>
            </div>

            {/* Section 2 */}
            <div className="vm-create-form-section">
              <div className="vm-create-section-number">2</div>

              <TextField
                className="vm-create-input"
                fullWidth
                label="Share Percentage"
                value={props.formData.share_percentage}
                onChange={(e) =>
                  props.handleInputChange("share_percentage", e.target.value)
                }
              />

              <Modal
                open={state.open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={modalStyle}>
                  <div className="vm-create-modal-header">
                    <img
                      onClick={handleClose}
                      className="vm-create-modal-back-arrow"
                      src={leftArrow}
                      alt="Back"
                    />
                    <h2 className="vm-create-modal-title">
                      Create Vending Machine
                    </h2>
                  </div>

                  <div className="vm-create-cohorts-modal">
                    <div className="vm-create-cohorts-search">
                      <input
                        type="search"
                        placeholder="Search by Cohort Name/ Cohort ID"
                        onChange={(e) => props.Search(e.target.value)}
                      />
                      <img
                        className="vm-create-cohorts-search-icon"
                        src={search}
                        alt="Search"
                      />
                    </div>

                    <div className="vm-create-cohorts-table-container">
                      <Table striped className="vm-create-cohorts-table">
                        <thead>
                          <tr>
                            <th>Cohort ID</th>
                            <th>Cohort Name</th>
                            <th>Area Name</th>
                            <th className="vm-create-cohorts-type-header">
                              <Dropdown className="vm-create-cohorts-dropdown">
                                <Dropdown.Toggle
                                  variant="none"
                                  className="vm-create-cohorts-dropdown-toggle"
                                >
                                  <img src={filter} alt="Filter" />
                                  <span>Cohort Type</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {props.stagecohortsTypes &&
                                    props.stagecohortsTypes.map((item) => (
                                      <Dropdown.Item
                                        key={item.id}
                                        id={item.id}
                                        active={
                                          props.activeCohortType === item.id
                                        }
                                        onClick={() =>
                                          props.handleCohortTypeClick(
                                            item.id,
                                            item.type,
                                          )
                                        }
                                      >
                                        {item.name}
                                      </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </th>
                            <th>Selction</th>
                          </tr>
                        </thead>

                        <tbody>
                          {props.FilterCohortData &&
                          props.FilterCohortData.length > 0 ? (
                            props.FilterCohortData.sort((a, b) =>
                              a.name.localeCompare(b.name),
                            ).map((el) => (
                              <tr key={el.id}>
                                <td>{el.id}</td>
                                <td>{el.name}</td>
                                <td>{el.area_name}</td>
                                <td className="vm-create-cohorts-type">
                                  {el.type}
                                </td>
                                <td>
                                  <input
                                    id={el.id}
                                    type="checkbox"
                                    className="vm-create-cohorts-checkbox"
                                    checked={props.selectedCohorts.includes(
                                      el.id,
                                    )}
                                    onChange={props.handleCheckboxClick}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                style={{ textAlign: "center", padding: "20px" }}
                              >
                                No cohort found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>

                    <div className="vm-create-cohorts-modal-buttons">
                      <Button
                        className="vm-create-cohorts-back-button"
                        onClick={handleClose}
                      >
                        Back
                      </Button>
                      <Button
                        className="vm-create-cohorts-save-button"
                        onClick={handleClose}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Box>
              </Modal>

              <div className="vm-create-cohorts-container">
                <p className="vm-create-cohorts-label">Cohorts</p>
                <Button
                  variant="outlined"
                  onClick={handleOpen}
                  className="vm-create-cohorts-button"
                >
                  Cohorts
                </Button>
              </div>

              <FormControl className="vm-create-select">
                <InputLabel>Payments</InputLabel>
                <Select
                  label="Payments"
                  multiple
                  value={
                    Array.isArray(props.formData.payment_config_ids)
                      ? props.formData.payment_config_ids
                      : []
                  }
                  onChange={(event) => handlePaymentChange(event.target.value)}
                  renderValue={(selected) => (
                    <div className="vm-create-payment-chips">
                      {selected.map((paymentId) => (
                        <Chip
                          key={paymentId}
                          label={
                            props.paymentList.find((el) => el.id === paymentId)
                              ?.name
                          }
                          onDelete={(event) =>
                            handleDeletePaymentChip(event, paymentId)
                          }
                          onMouseDown={(event) => event.stopPropagation()}
                          className="vm-create-payment-chip"
                        />
                      ))}
                    </div>
                  )}
                >
                  {props.paymentList &&
                    props.paymentList.map((el) => (
                      <MenuItem key={el.id} value={el.id}>
                        {el.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <TextField
                className="vm-create-input"
                fullWidth
                label="Serial Number"
                value={props.formData.serial_number}
                onChange={(e) =>
                  props.handleInputChange("serial_number", e.target.value)
                }
              />

              <TextField
                className="vm-create-input"
                fullWidth
                label="Slot ID"
                type="number"
                autoComplete="off"
                value={props.formData.slot_id}
                onChange={(e) =>
                  props.handleInputChange("slot_id", e.target.value)
                }
              />

              <TextField
                className="vm-create-input"
                fullWidth
                label="MV ID"
                type="number"
                value={props.formData.mv_id}
                onChange={(e) =>
                  props.handleInputChange("mv_id", e.target.value)
                }
              />

              <TextField
                className="vm-create-input"
                fullWidth
                label="Capacity"
                type="number"
                value={props.formData.capacity}
                onChange={(e) =>
                  props.handleInputChange("capacity", e.target.value)
                }
              />

              <FormControl className="vm-create-select">
                <InputLabel>Franchise Type</InputLabel>
                <Select
                  value={props.formData.type}
                  onChange={handleTypeChange}
                  label="Franchise Type"
                >
                  <MenuItem value="CITY">FOCO(City)</MenuItem>
                  <MenuItem value="FRANCHISEE">FOFO (FRANCHISEE)</MenuItem>
                  <MenuItem value="PDF">Pdf (PDF)</MenuItem>
                </Select>
              </FormControl>

              {props.formData.type === "FRANCHISEE" && (
                <>
                  <FormControl className="vm-create-select">
                    <InputLabel>Location Type</InputLabel>
                    <Select
                      value={props.formData.type_detail}
                      onChange={handleDetailChange}
                      label="Location Type"
                    >
                      <MenuItem value="location given by daalchini">
                        Location Given By Daalchini
                      </MenuItem>
                      <MenuItem value="location given by fofo">
                        Location Given By FOFO
                      </MenuItem>
                    </Select>
                  </FormControl>

                  {/* VM Operation Type - Radio Buttons */}
                  <div className="vm-create-operation-type-container">
                    <FormLabel
                      component="legend"
                      className="vm-create-operation-label"
                    >
                      VM Operation Type
                    </FormLabel>
                    <RadioGroup
                      row
                      value={props.formData.vm_operation_type || ""}
                      onChange={handleOperationTypeChange}
                      className="vm-create-radio-group"
                    >
                      <FormControlLabel
                        value="PURCHASE"
                        control={<Radio />}
                        label="Purchase"
                        className="vm-create-radio-label"
                      />
                      <FormControlLabel
                        value="REFILLING"
                        control={<Radio />}
                        label="Refilling"
                        className="vm-create-radio-label"
                      />
                    </RadioGroup>
                  </div>
                </>
              )}
            </div>

            {/* Section 3 */}
            <div className="vm-create-form-section">
              <div className="vm-create-section-number">3</div>

              <TextField
                className="vm-create-input"
                fullWidth
                label="BDPOC"
                value={props.formData.bd_spoc}
                onChange={(e) =>
                  props.handleInputChange("bd_spoc", e.target.value)
                }
              />

              <FormControl className="vm-create-select">
                <InputLabel>Location Type</InputLabel>
                <Select
                  label="Location Type"
                  value={props.formData.location_type_id}
                  onClick={() => setState({ ...state, showLocationType: true })}
                >
                  {props.locationType &&
                    props.locationType.map((el, index) => (
                      <MenuItem
                        key={index}
                        value={el.id}
                        onClick={() => handleLocationTypeChange(el.id)}
                      >
                        {el.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <TextField
                className="vm-create-input"
                fullWidth
                label="Location"
                value={props.formData.location}
                onChange={(e) =>
                  props.handleInputChange("location", e.target.value)
                }
              />

              <FormControl className="vm-create-select">
                <InputLabel>State</InputLabel>
                <Select
                  label="State"
                  open={props.showStateList}
                  onClose={() => props.setShowStateList(false)}
                  onOpen={() => {
                    props.setShowStateList(true);
                    props.handleGetStateName();
                  }}
                  value={props.formData.state}
                >
                  {props.stateName.list &&
                    props.stateName.list.map((el, index) => (
                      <MenuItem
                        key={index}
                        value={el.name}
                        onClick={() => {
                          props.handleInputChange("state", el.name);
                          props.setShowStateList(false);
                          props.handleGetCityName(el.id);
                        }}
                      >
                        {el.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <FormControl className="vm-create-select">
                <InputLabel>City</InputLabel>
                <Select
                  label="City"
                  value={props.formData.city}
                  onClick={() => props.setShowCityList(true)}
                >
                  {props.cityName.list &&
                    props.cityName.list.map((el, index) => (
                      <MenuItem
                        key={index}
                        value={el.name}
                        onClick={() => {
                          props.handleInputChange("city", el.name);
                          props.setShowCityList(false);
                        }}
                      >
                        {el.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <TextField
                className="vm-create-input"
                fullWidth
                label="Latitude"
                value={props.formData.latitude}
                onChange={(e) =>
                  props.handleInputChange("latitude", e.target.value)
                }
              />

              <TextField
                className="vm-create-input"
                fullWidth
                label="Longitude"
                value={props.formData.longitude}
                onChange={(e) =>
                  props.handleInputChange("longitude", e.target.value)
                }
              />

              <div className="vm-create-image-upload-container">
                <input
                  accept="image/*"
                  id="uploadImage"
                  type="file"
                  onChange={props.handleFileChange}
                  className="vm-create-file-input"
                />

                <label htmlFor="uploadImage" className="vm-create-upload-label">
                  {props.imagePreview ? (
                    <div className="vm-create-image-preview">
                      <img
                        src={props.imagePreview}
                        alt="Preview"
                        className="vm-create-preview-image"
                      />
                      <img
                        src={cancel}
                        alt="Cancel"
                        onClick={props.handleCancel}
                        className="vm-create-cancel-image"
                      />
                    </div>
                  ) : (
                    <div className="vm-create-upload-content">
                      <IconButton color="primary" component="span">
                        <CloudUploadIcon />
                      </IconButton>
                      <span className="vm-create-upload-text">
                        Click here to select an image
                      </span>
                    </div>
                  )}
                </label>

                <Button
                  variant="outlined"
                  onClick={props.handleImageUpload}
                  className="vm-create-upload-button"
                >
                  Upload
                </Button>

                {props.isImageUploaded && (
                  <p className="vm-create-upload-success">Image Uploaded</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <Button
          className="vm-create-submit-button"
          onClick={props.handleCreateVm}
        >
          Create Vending Machine
        </Button>
      </div>
    </div>
  );
};

export default VmCreateComponent;
